import { Units } from "../../types/project";

export class UnitConverter {
  private metresToSurveyFeetRatio = 1200 / 3937;
  private metresToFeetRatio = 0.3048;

  public convert(value, fromUnits: Units, toUnits: Units, fixedLength=null) {
    const allowedUnits = Object.values(Units);

    if (!allowedUnits.includes(fromUnits)) {
      throw TypeError(`Units must be ${allowedUnits}`);
    }

    if (!allowedUnits.includes(toUnits)) {
      throw TypeError(`Units must be ${allowedUnits}`);
    }

    if (isNaN(value)) {
      throw new Error('Value must be a number');
    }

    let convertedValue = value;

    if (fromUnits !== toUnits) {
      const ratio = fromUnits === Units.Feet
        ? this.metresToFeetRatio
        : this.metresToSurveyFeetRatio;

      if (fromUnits === Units.Feet || fromUnits === Units.SurveyFeet) {
        convertedValue *= ratio;
      }

      if (toUnits === Units.Feet || toUnits === Units.SurveyFeet) {
        convertedValue /= ratio;
      }
    }

    if (fixedLength !== null) {
      convertedValue = parseFloat(convertedValue.toFixed(fixedLength));
    }

    return convertedValue;
  }
}
